// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2n8w9","col":"styles_col__2Z7pF","fulfillmentStatus":"styles_fulfillmentStatus__2kvx9","emailCol":"styles_emailCol__3ds8i"};